import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { c as _c } from "react-compiler-runtime";
import { useState, useCallback } from 'react';
import { getInitialCollaborationSidebarState, mergeCollaborationSidebarState } from '../utils/collaborationSidebarState';
import ControlledCollaborationSidebarProvider from './ControlledCollaborationSidebarProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CollaborationSidebarProvider(t0) {
  "use memo";

  const $ = _c(8);
  let children;
  let props;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children
    } = _t);
    props = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const [collaborationSidebarState, setCollaborationSidebarState] = useState(_temp);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = updates => {
      setCollaborationSidebarState(state => mergeCollaborationSidebarState(state, updates));
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onUpdateCollaborationSidebarState = t1;
  let t2;
  if ($[4] !== children || $[5] !== collaborationSidebarState || $[6] !== props) {
    t2 = /*#__PURE__*/_jsx(ControlledCollaborationSidebarProvider, Object.assign({}, props, {
      collaborationSidebarState: collaborationSidebarState,
      onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
      children: children
    }));
    $[4] = children;
    $[5] = collaborationSidebarState;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp() {
  return getInitialCollaborationSidebarState();
}